import { render, staticRenderFns } from "./OrderItemsEdit.vue?vue&type=template&id=55270d4d"
import script from "./OrderItemsEdit.vue?vue&type=script&lang=js"
export * from "./OrderItemsEdit.vue?vue&type=script&lang=js"
import style0 from "./OrderItemsEdit.vue?vue&type=style&index=0&id=55270d4d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports